import React from "react";

export const SupplierGridCardSkeleton = () => (
  <li className="acc-card sv-card is-skeleton" aria-hidden="true">
    <span className="acc-card-button">
      <span className="acc-card-media">
        <span className="acc-shimmer acc-shimmer-media" />
      </span>

      <span className="acc-card-body">
        <span className="acc-shimmer acc-shimmer-line acc-shimmer-name" />
        <span className="acc-shimmer acc-shimmer-line acc-shimmer-short" />

        <span className="acc-card-facts">
          <span className="acc-shimmer acc-shimmer-line acc-shimmer-supplier" />
          <span className="acc-shimmer acc-shimmer-line acc-shimmer-price" />
        </span>
      </span>
    </span>
  </li>
);

export const SavedSuppliersGridSkeleton = ({ cards = 10 }) => (
  <ul className="acc-grid" aria-hidden="true">
    {Array.from({ length: cards }, (unused, index) => (
      <SupplierGridCardSkeleton key={index} />
    ))}
  </ul>
);

export const SavedCountSkeleton = () => (
  <span className="acc-shimmer acc-shimmer-line acc-shimmer-count" aria-hidden="true" />
);
